import React, { useEffect, useState } from 'react';
import { Platform, ScrollView, Text, View } from 'react-native';
import { useLocalSearchParams } from 'expo-router';
import { StyleSheet } from 'react-native-unistyles';
import FormPaymentCheckout from '@/components/Forms/FormPaymentCheckout';

export default function FormPaymentPage() {
    const params = useLocalSearchParams();
    const [token, setToken] = useState(null);
    useEffect(() => {
        // Public links carry the token in the hash (kept out of logs); in-app
        // navigation passes it as a router param. Accept both.
        const hash = Platform.OS === 'web' ? window.location.hash.slice(1) : null;
        const candidate = hash || params['#'] || params.token;
        if (typeof candidate === 'string' && /^[a-f0-9]{64}$/.test(candidate)) setToken(candidate);
    }, [params.token, params['#']]);
    return (
        <ScrollView contentContainerStyle={styles.content} keyboardShouldPersistTaps="handled">
            <View style={styles.card}>
                <Text style={styles.heading}>Form Payment</Text>
                {token ? <FormPaymentCheckout token={token} /> : <Text style={styles.text}>Open the complete payment link provided after submission or by an entry manager.</Text>}
            </View>
        </ScrollView>
    );
}

const styles = StyleSheet.create(({ colors, fonts, spacing, roundness, shadows, typography }) => ({
    content: { padding: spacing.lg, alignItems: 'center' },
    card: { width: '100%', maxWidth: 640, padding: spacing.lg, gap: spacing.md, backgroundColor: colors.surface, borderRadius: roundness.md, boxShadow: shadows.card },
    heading: { color: colors.forms, fontFamily: fonts.heading, fontSize: typography.h2 },
    text: { color: colors.textSecondary, fontFamily: fonts.body, fontSize: typography.body },
}));
